module.exports = __webpack_public_path__ + "static/media/14001.f0b26dc8.jpg";